<script lang="ts" setup>
defineProps<{
  title?: string
  description: string
  btnText?: string
}>()

const emit = defineEmits<{
  (e: 'btnClicked'): void
}>()
</script>

<template>
  <div class="hint-box">
    <div class="modal__update-warning-icon">
      <i class="ic-alert" />
    </div>

    <div class="warning-text">
      <p v-if="title">
        <b>{{ title }}</b>
      </p>
      <span>{{ description }}</span>
    </div>

    <button v-if="btnText" class="btn" @click="emit('btnClicked')">
      {{ btnText }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.hint-box {
  width: 100%;
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: $hintBgColor;
  border: 1px solid $hintBorderColor;

  @include themify($themes) {
    border-radius: rem-calc(themed('cardBorderRadius'));
  }

  @include media('<tablet') {
    flex-direction: column;
  }

  .modal__update-warning-icon {
    color: $hintIconColor;
  }

  .warning-text {
    flex: 1;
  }
}
</style>
